import * as actionTypes from "./actionTypes";

export const authUpdateState = (authData) => ({
  type: actionTypes.AUTH_UPDATE_STATE,
  authData: authData,
});

export const updatePurchased = (purchased) => ({
  type: actionTypes.UPDATE_PURCHASED,
  purchased,
});

export const setSettingsModal = (show) => ({
  type: actionTypes.SET_SETTINGS_MODAL,
  show: show,
});

export const setPasswordResetModal = (show) => ({
  type: actionTypes.SET_PASSWORD_RESET_MODAL,
  show: show,
});

export const setMailchimpTags = (tags) => ({
  type: actionTypes.SET_MAILCHIMP_TAGS,
  tags: tags,
});

export const setCurrentCategory = (category) => ({
  type: actionTypes.SET_CURRENT_CATEGORY,
  category: category,
});

export const setIncludeNSFW = (include) => ({
  type: actionTypes.SET_INCLUDE_NSFW,
  include: include,
});
